import * as yup from 'yup';
import { Gender, values } from '../enums';

export const NameSchema = yup.object({
  last: yup.string().required(),
  firstFull: yup.string().required(),
  firstCall: yup.string().notRequired(),
  title: yup.string().notRequired().nullable(),
  gender: yup.mixed<Gender>().oneOf(values(Gender)).notRequired().nullable(),
  birthName: yup.string().notRequired(),
});

export const EmployeeNameSchema = yup.object({
  last: yup.string().required(),
  firstFull: yup.string().required(),
  firstCall: yup.string().notRequired(),
  title: yup.string().notRequired().nullable(),
  gender: yup.mixed<Gender>().oneOf(values(Gender)).required(),
  birthName: yup.string().notRequired(),
});

export const ResidentNameSchema = yup.object({
  last: yup.string().required(),
  firstFull: yup.string().required(),
  firstCall: yup.string().notRequired(),
  title: yup.string().notRequired().nullable(),
  gender: yup.mixed<Gender>().oneOf(values(Gender)).required(),
  birthName: yup.string().notRequired(),
});

export interface IName {
  last: string;
  firstFull: string;
  firstCall?: string;
  title?: string;
  gender?: Gender;
  birthName?: string;
}

export function formatFullName(name: IName): string {
  return `${name.last},${name.title ? ' ' + name.title : ''} ${name.firstFull}`;
}
